import Zone from '../views/zone/zonelisting';
import tc from '../views/tc/listingtc';
import TariffCard from '../views/tariffcard/tariffcardlisting';
import ServiceAreaTemplate from '../views/ServiceAreaTemplate/serviceAreaListing';
import ContractTemplate from '../views/contracttemplate/contracttemplateListing';
import RateTemplate from '../views/ratetemplate/ratetemplatelisting';
import ServiceLevelTemplate from '../views/ServiceLevelTemplate/ServiceLevelListing';
import Slabs from '../views/Slabs/slabListing';
import ODAChargeTemplate from '../views/ODAChargeTemplate/ODAChargeListing';
import ApprovalHierarchy from '../views/ApprovalHierarchy/approvalHierarchy';
import BoxType from '../views/BoxType/boxlisting';
import ClientEBNExemptionConfig from '../views/ClientEBNExemptionConfig';
import PortToPortListing from '../views/AirWalletTemplate/porttoportlisting'
import AirlineVersion from '../views/AirWalletTemplate/airlineversion'
import AirWalletTemplate from '../views/AirWalletTemplate/porttoport/';
import viewratetemplate from '../views/AirWalletTemplate/viewairratetemplate';
export default [{
		path: '/cargomaster/zones',
		name: 'cargomaster-zone',
		component: Zone,
		title: 'cargomaster-zone',
		meta: {
      requiresAuth: true
    }
	}, {
		path: '/cargomaster/tariffcard',
		name: 'cargomaster-tariffcard',
		component: TariffCard,
		title: 'cargomaster-tariffcard',
		meta: {
      requiresAuth: true
    }
	}, {
		path: '/cargomaster/ratetemplate',
		name: 'cargomaster-ratetemplate',
		component: RateTemplate,
		title: 'cargomaster-ratetemplate',
		meta: {
      requiresAuth: true
    }
	}, {
		path: '/cargomaster/contracttemplate',
		name: 'cargomaster-contracttemplate',
		component: ContractTemplate,
		title: 'cargomaster-contracttemplate',
		meta: {
      requiresAuth: true
    }
	},
	{
		path: '/cargomaster/serviceAreaTemplate',
		name: 'cargomaster-serviceAreaTemplate',
		component: ServiceAreaTemplate,
		title: 'cargomaster-serviceAreaTemplate',
		meta: {
      requiresAuth: true
    }
	},
	{
		path: '/cargomaster/ServiceLevelTemplate',
		name: 'cargomaster-ServiceLevelTemplate',
		component: ServiceLevelTemplate,
		title: 'cargomaster-ServiceLevelTemplate',
		meta: {
      requiresAuth: true
    }
	},
	{
		path: '/cargomaster/odachargestemplate',
		name: 'cargomaster-odachargestemplate',
		component: ODAChargeTemplate,
		title: 'cargomaster-odachargestemplate',
		meta: {
      requiresAuth: true
    }
	},
	{
		path: '/cargomaster/slabs',
		name: 'cargomaster-slabs',
		component: Slabs,
		title: 'cargomaster-slabs',
		meta: {
      requiresAuth: true
    }
	},
	{
		path: '/cargomaster/termsandcondition',
		name: 'cargomaster-termsandconditions',
		component: tc,
		title: 'cargomaster-termsandconditions',
		meta: {
      requiresAuth: true
    }
	},
	{
		path: '/cargomaster/approvalhierarchy',
		name: 'cargomaster-approvalhierarchy',
		component: ApprovalHierarchy,
		title: 'cargomaster-approvalhierarchy',
		meta: {
      requiresAuth: true
    }
	},
	{
    path: '/cargomaster/boxtype',
    name: 'cargomaster-boxtype',
    component: BoxType,
		title: 'cargomaster-boxtype',
		meta: {
      requiresAuth: true
    }
  },
	{
    path: '/cargomaster/clientebnexemption',
    name: 'cargomaster-clientebnexemption',
    component: ClientEBNExemptionConfig,
		title: 'cargomaster-clientebnexemption',
		meta: {
      requiresAuth: true
    }
	},
	{
		path: '/cargomaster/airwallettemplate/porttoportlisting',
		name: 'cargomaster-porttoportlisting',
		component: PortToPortListing,
		title: 'cargomaster-porttoportlisting',
		meta: {
			//   requiresAuth: true
		}
	},
	{
		path: '/cargomaster/airwallettemplate/airlineversion',
		name: 'cargomaster-airlineversion',
		component: AirlineVersion,
		title: 'cargomaster-airlineversion',
		meta: {
			requiresAuth: true
		}
	},
	{
		path: '/cargomaster/airwallettemplate/viewratetemplate',
		name: 'cargomaster-viewratetemplate',
		component: viewratetemplate,
		title: 'cargomaster-viewratetemplate',
		meta: {
			  requiresAuth: false
		}
	},
];



// WEBPACK FOOTER //
// ./src/modules/masterdata/router/index.js